import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { createPlayerEventKey } from '@/feature/betslip-pickem/utils/markets-cache-store-utils';
import { ProductDocumentDataBodyLobbycomponentsSliceItem } from '@/types/prismic.generated';

export enum LobbyComponent {
    PromoCarousel = 'promo_carousel',
    FeaturedPlayersList = 'trending_players',
    FeaturedLineups = 'prebuilt_lineups',
    PopularPlayers = 'popular_players',
    FavoritesPlayers = 'favorites_players',
    RaceToPlace = 'race_to_place',
}

export const DEFAULT_LOBBY_ORDERING: ProductDocumentDataBodyLobbycomponentsSliceItem[] = [
    { enabled: true, header: '', orderingkey: LobbyComponent.PromoCarousel },
    { enabled: true, header: 'Featured lineups', orderingkey: LobbyComponent.FeaturedLineups },
    { enabled: true, header: 'Trending Players', orderingkey: LobbyComponent.FeaturedPlayersList },
    { enabled: true, header: 'Top 10 players', orderingkey: LobbyComponent.PopularPlayers },
    { enabled: true, header: 'Race to Place', orderingkey: LobbyComponent.RaceToPlace },
    { enabled: true, header: 'Favorites', orderingkey: LobbyComponent.FavoritesPlayers },
];

export const extractPlayersListKey = (element: PlayerWithTeamAndEvent, index: number, fetching: boolean) => {
    if (fetching) {
        return `${index}`;
    }

    return createPlayerEventKey(element.id, element.event.id);
};
